export const sendFormSubmissionDetails = (formData, title) => {
  const entries = Object.entries(formData)
    .map(
      ([key, value]) => `
      <tr>
        <td style="padding: 8px 12px; border: 1px solid #ddd;">
          <strong>${key}</strong>
        </td>
        <td style="padding: 8px 12px; border: 1px solid #ddd;">
          ${value || "-"}
        </td>
      </tr>`
    )
    .join("");

  return `
<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <title>Demo Request AI Global</title>
  </head>
  <body style="font-family: Poppins, sans-serif; background: #f8f9fa; color: #333;">
    <table width="100%" cellpadding="0" cellspacing="0" style="margin: 0; padding: 20px;">
      <tr>
        <td align="center">
          <table width="600" cellpadding="0" cellspacing="0" style="background: #fff; border: 1px solid #eaeaea; border-radius: 8px;">
            <tr>
              <td style="padding: 20px; text-align: center;">
                <img
                  src="https://res.cloudinary.com/analytics-intelligence/image/upload/v1753965590/companyLogo_tlid88.png"
                  alt="Analytic inteliigence"
                  style="max-width: 180px;"
                />
                <h2 style="color: #1a8aff;">${title}</h2>
              </td>
            </tr>
            <tr>
              <td style="padding: 20px;">
                <p>Hi Team,</p>
                <p>A new form has been submitted. Below are the details:</p>
                <table style="width: 100%; border-collapse: collapse; margin-top: 10px; font-size: 14px;">
                  ${entries}
                </table>
                <p style="margin-top: 20px;">Regards,<br/>Analytics Intelligence Team</p>
              </td>
            </tr>
            <tr>
              <td style="padding: 10px; text-align: center; background: #f0f0f0; font-size: 12px; color: #666;">
                 <a href='https://africa.analyticsintelligence.com>Form submission page</a>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </body>
</html>`;
};